export type BrandedString<T extends symbol, S extends string = string> = {
  readonly __typeTag: T;
} & S;

export function getBrandedString<T extends symbol, S extends string>(
  str: S,
): BrandedString<T, S> {
  // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
  return str as BrandedString<T, S>;
}
